import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { usePageLanguage } from '@/hooks/usePageLanguage';
import { useJsonLd } from '@/hooks/useJsonLd';
import { SITE_ORIGIN } from '@/data/site';
import Hero from './components/Hero';
import ValueProps from './components/ValueProps';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import HowItWorks from './components/HowItWorks';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import FinalCta from './components/FinalCta';

export default function Home() {
  const { lang = 'en' } = useParams();
  const { t } = useTranslation();
  usePageLanguage(lang);

  useJsonLd('site-schema', [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: t('logo.name'),
      url: SITE_ORIGIN,
      description: t('meta.description'),
      inLanguage: ['en', 'fr', 'de', 'es', 'pt'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: t('logo.name'),
      url: SITE_ORIGIN,
      description: t('meta.description'),
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png',
    },
  ]);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ValueProps />
        <CategoryGrid />
        <AboutSection />
        <HowItWorks />
        <TopicsSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}